<template>
  <div
    class="py-3 sm:pt-0 sm:pb-6 border-b sm:border-b-0 sm:border-t border-primary_900 cursor-pointer"
    @click="showDetailsDialog = true"
  >
    <div class="flex items-center justify-between my-2">
      <div class="flex gap-2 items-center">
        <UserPicture gap="gap-2" :user="props.review.user" />
        <p class="text-[12px] font-medium leading-[150%] text-neutral_50">
          {{ calculateTimeAgo(props.review.created_at) }}
        </p>
      </div>
      <div class="flex items-center gap-4">
        <ButtonComponent
          v-if="!commonStore.isMobile"
          :text="`${$t('gradeDetails')}`"
          type="text"
          @click="showDetailsDialog = true"
        />
        <!-- <ClientOnly>
          <StarRating
            :star-size="12"
            :padding="4"
            inactive-color="#fff"
            active-color="#86C232"
            :read-only="true"
            :show-rating="false"
            :rating="props.review.avgReviewScore"
          />
        </ClientOnly> -->
        <BoneRating :rating="props.review.avgReviewScore" />
      </div>
    </div>
    <p class="text-base text-neutral_50 font-medium leading-[150%]">
      {{ props.review.reviewText }}
    </p>
  </div>
  <BettingShopsReviewDetailsDialog
    :review="props.review"
    :is-open="showDetailsDialog"
    @close-dialog="showDetailsDialog = false"
  />
</template>
<script setup lang="ts">
import { useCommonStore } from '~/store/commonStore';
import ButtonComponent from '../Common/ButtonComponent.vue';
// import StarRating from 'vue-star-rating';
const props = defineProps({
  review: {
    type: Object,
    required: true
  }
});
const { calculateTimeAgo } = useTimeFunctions();
const commonStore = useCommonStore();
const showDetailsDialog = ref(false);
</script>
